import { render, staticRenderFns } from "./NewPatientCard.vue?vue&type=template&id=35ce89ae&scoped=true&"
import script from "./NewPatientCard.vue?vue&type=script&lang=js&"
export * from "./NewPatientCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce89ae",
  null
  
)

export default component.exports